<template>
  <b-nav-item-dropdown class="d-md-down-none" right>
    <template slot="button-content">
      <i class="fa fa-bell faa-ring" v-bind:class="{ animated: isRinging }" @click="isRinging = false"></i>
      <b-badge pill variant="danger" v-if="notificationList.length">{{notificationTotals}}</b-badge>
    </template>
    <template v-if="notificationList.length">
      <b-dropdown-item v-for="notification in notificationList" v-bind:key="notification.notificationUuid" @click="readNotification(notification.notificationUuid, notification.uuid, notification.type)" class="notification-item">
        <div class="text">
          <h4>{{notification.title}}</h4>
          <p>{{notification.createdAt}}</p>
        </div>
      </b-dropdown-item>
    </template>
    <template v-else>
      <b-dropdown-item class="notification-item" >
        <p class="mb-0">No Unread Notifications</p>
      </b-dropdown-item>
    </template>
    <b-dropdown-item class="notification-item notification-footer show-all-notif" @click="asideToggle">
      <b>See All Notifications</b>
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>
<script>
export default {
  name: 'header-notification',
  props: {
    afterClickNotification: {
      type: Function
    }
  },
  data () {
    return {
      notificationList: [],
      notificationTotals: null,
      setReadNotificationUuid: null,
      isRinging: false
    }
  },
  methods: {
    setNotificationList (data) {
      this.notificationList = data
    },
    setNotificationTotals (data) {
      this.notificationTotals = data
    },
    readNotification (notificationUuid, uuid, type) {
      this.afterClickNotification(notificationUuid, uuid, type)
    },
    asideToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('aside-menu-hidden')
    }
  },
  mounted () {
    if (this.$route.query.notification_uuid !== undefined) {
      this.readNotification(this.$route.query.notification_uuid, null, 'browserNotif')
    }
  }
}
</script>

<style lang="scss" scoped>
    .notification-item {
        padding-top: 5px;
        padding-bottom: 5px;
        position: relative;
        .dot {
            color: #f86c6b;
            vertical-align: top;
            padding-right: 5px;
            font-size: 20px;
            /* top: 0; */
            height: 100%;
            margin: 0;
            /* padding: 0; */
            /* float: left; */
            position: absolute;
            top: 2px;
        }
        .text {
            display: inline-block;
            /* float: left; */
            // padding-left: 26px;
            h4 {
                margin: 0;
                font-size: 95%;
                margin: 0px;
            }
            p {
                font-size: 90%;
                color: #c3c3c3;
                margin: 0px;
            }
        }
        &.notification-footer {
            font-size: 95%;
            padding-top: 5px;
            padding-bottom: 5px;
            text-align: center;
            background: #f0f3f5;
            display: block;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/HeaderNotification.vue